import { Injectable, Injector } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CoreConfigurationsLoader } from '@vfde-fe/ngx-lib/services/core-configurations-loader';
import { config } from '../../../config/pages-config';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

/** ConfigLoaderService */
@Injectable({
    providedIn: 'root',
  })
export class ConfigLoaderService extends CoreConfigurationsLoader {

    private errors: any;
    /** deWordingfile */
    public deWordingfile: any;
    private commonErrors: any;
    private reasonsCodes: any;
    private holidayList: any;
    /** defaultGermanWordingfile */
    public defaultGermanWordingfile: any;
    /** constructor */
    public constructor (private injector: Injector) {
        super();
    }
    /**
     * load regex configuration file
     */
    public load (): Promise<any> {

        const errorsConfig = new Promise((resolve, reject) => {
            setTimeout(() => {
                const http = this.injector.get(HttpClient);
                http.get(environment.cmsWordingPath + 'error-messages.json').subscribe(response => {

                    try {

                        this.errors = response;

                        resolve(this.errors);
                    } catch (error) {

                        console.warn('not valid json for error-messages.json file');

                        http.get(environment.configPath + 'error-messages.json').subscribe(response => {
                            this.errors = response;
                            resolve(this.errors);
                        });
                    }
                }, error => {
                    http.get(environment.configPath + 'error-messages.json').subscribe(response => {
                        this.errors = response;
                        resolve(this.errors);
                    });
                });
            });
        });

        const commonErrorsConfig = new Promise((resolve, reject) => {
            setTimeout(() => {
                const http = this.injector.get(HttpClient);
                http.get(environment.cmsErrorMessagesPath + 'common.error.js').subscribe(response => {

                    try {

                        this.commonErrors = response;

                        resolve(this.commonErrors);
                    } catch (error) {

                        console.warn('not valid json for common.error.js file');

                        http.get(environment.configPath + 'common.error.json').subscribe(response => {
                            this.commonErrors = response;
                            resolve(this.commonErrors);
                        });
                    }

                }, error => {
                    http.get(environment.configPath + 'common.error.json').subscribe(response => {
                        this.commonErrors = response;
                        resolve(this.commonErrors);
                    });
                });
            });
        });

        const deWording = new Promise((resolve, reject) => {
            setTimeout(() => {

                const http = this.injector.get(HttpClient);
                http.get(environment.cmsWordingPath + 'i18n/deWording.json').subscribe(response => {
                    try {

                        this.defaultGermanWordingfile = response;

                        resolve(this.defaultGermanWordingfile);
                    } catch (error) {

                        console.warn('not valid json for deWording.json file');
                        resolve(null);
                    }
                }, (err) => {
                    resolve(null);
                });
            });
        });

        const getGermanWording = new Promise((resolve, reject) => {

            deWording.then((value) => {

                if (!value) {

                    setTimeout(() => {
                        const http = this.injector.get(HttpClient);
                        http.get(environment.configPath + 'i18n/defaultWording.json').subscribe(response => {
                            this.defaultGermanWordingfile = response;
                            resolve(this.defaultGermanWordingfile);
                        });
                    });
                } else {
                    resolve(value);
                }
            });
        });

        return Promise.all([errorsConfig, commonErrorsConfig, getGermanWording]);
    }
/** loadPagesRoutes */
    public loadPagesRoutes (): object | object[] {
        return config;
    }
/** getcommonErrorsConfig */
    public getcommonErrorsConfig () {
        return this.commonErrors;
    }
/** getErrorsConfig */
    public getErrorsConfig () {
        return this.errors;
    }
    /** getDefaultGermanWordingFile */
    public getDefaultGermanWordingFile () {
        return of(this.defaultGermanWordingfile);
    }
    /** getDeWordingFile */
    public getDeWordingFile () {
        return of(this.defaultGermanWordingfile);
    }
    /** setCoreConfigRoute */
    public setCoreConfigRoute (): void {
        this.generalError = this.loadPagesRoutes()['generalError'].route;
        this.unauthorized = this.loadPagesRoutes()['unauthorized'].route;
    }

       /** getTokenConfig */
    public getTokenConfig (): string {

        return '';
    }

    /**
     * get all reasons codes
     */
    public getReasonsCodes () {
        return new Promise((resolve, reject) => {
            const http = this.injector.get(HttpClient);
            if (this.reasonsCodes) {
                resolve(this.reasonsCodes);
            } else {
                http.get(environment.cmsConfigPath + 'reasons-config.json').subscribe(response => {

                    try {

                        this.reasonsCodes = response;

                        resolve(this.reasonsCodes);
                    } catch (error) {

                        http.get(environment.configPath + 'reasons-config.json').subscribe(response => {
                            this.reasonsCodes = response;
                            resolve(this.reasonsCodes);
                        });
                    }
                }, error => {
                    http.get(environment.configPath + 'reasons-config.json').subscribe(response => {
                        this.reasonsCodes = response;
                        resolve(this.reasonsCodes);
                    });
                });
            }
        });
    }
    /** getHolidayDates */
    public getHolidayDates () {
        return new Promise((resolve, reject) => {
            const http = this.injector.get(HttpClient);
            if (this.holidayList) {
                resolve(this.holidayList);
            } else {
                /** cmsConfigPath when CMS */
                http.get(environment.configPath + 'holidayList.json').subscribe(response => {

                    try {

                        this.holidayList = response;

                        resolve(this.holidayList);
                    } catch (error) {

                        http.get(environment.configPath + 'holidayList.json').subscribe(response => {
                            this.holidayList = response;
                            resolve(this.holidayList);
                        });
                    }
                }, error => {
                    http.get(environment.configPath + 'holidayList.json').subscribe(response => {
                        this.holidayList = response;
                        resolve(this.holidayList);
                    });
                });

                return this.holidayList;
            }
        });
    }
}
